import { AppRouter } from '@/routes'

export default function App() {
  return <AppRouter />
}
